import api from "./api";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads/image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // {id, path, url}
}

export function authImageUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  const token = localStorage.getItem("auth_token") || "";
  // Accept either a full URL "/api/files/..." or a bare storage path
  const path = pathOrUrl.startsWith("/api/files/")
    ? pathOrUrl.slice("/api/files/".length)
    : pathOrUrl;
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/files/${path}?auth=${encodeURIComponent(token)}`;
}
